import ApiBase from '../ApiBase';

import {downloadFileFromApi} from 'Services/BaseHelpers';

class Download extends ApiBase {
    route = '/download';

    /**
     * @method download
     * @param {string} id
     * @param {object} data
     * @param {Object} fileName
     * @return {Promise<boolean|{status: number}>}
     */
    download = async (fileName) => {
        let resource = {};
        let data = {};
        return this.downloadFile(
            this.route + '/downloadS3',
            {
                key: fileName,
            },
            fileName
        );
    };
}

export default new Download();
